<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="ownerProfiles" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="ownerProfileId"
  selectionMode="single" [(selection)]="ownerProfile" (onRowSelect)="onRowSelect($event)" [columns]="columns"
  [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Owner Profiles</h1>
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="pt.exportCSV()">Clear Filters</button>

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New OwnerProfile +</button>
        <app-import-export (dataAndTagsSelected)="dataAndTagSelected($event)" [tagsourceForInput]="50" [dataRetrived]="ownerProfiles"
        (exportDataSelected)="exportSelected($event)" [sampleFileLink]="sampleLink" [columns]="columns"></app-import-export>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}">Tags</th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    <tr>
      <th>
        <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="listingStatuses" appendTo="body"
          (onChange)="pt.filter($event.value, 'listingStatus', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'firstName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lastName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'emailAddress', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'mobilePhone', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'spouseFirstName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'spouseLastName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'spouseEmailAdress', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'PropertyProfileVOList.propertyName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'PropertyProfileVOList.ShortTermRentalVO.propertyCode', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'compHostNights', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'satisfactionRank', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><app-tag-join-filter-select [tagSource]="50" (getFilteredTags)="getFilteredTags($event)"></app-tag-join-filter-select></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-ownerProfile>
    <tr [pSelectableRow]="ownerProfile">
      <td>{{getStatusName(ownerProfile)}}</td>
      <td>{{ownerProfile.firstName}}</td>
      <td>{{ownerProfile.lastName}}</td>
      <td>{{ownerProfile.emailAddress}}</td>
      <td>{{ownerProfile.mobilePhone}}</td>
      <td>{{ownerProfile.spouseFirstName}}</td>
      <td>{{ownerProfile.spouseLastName}}</td>
      <td>{{ownerProfile.spouseEmailAdress}}</td>
      <td>{{getPropertyName(ownerProfile.propertyProfileVOList)}}</td>
      <td>{{getPropertyCode(ownerProfile.propertyProfileVOList)}}</td>
      <td>{{ownerProfile.compHostNights}}</td>
      <td>{{getSatisfactionRankName(ownerProfile)}}</td>
      <app-tag-join-list-select [tagSource]="50" [tagSourceId]="ownerProfile.ownerProfileId" tagType="4"></app-tag-join-list-select>
      <td><span style="float:none">
        <a>
          <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit(ownerProfile)">edit</mat-icon>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>
